const GA_MEASUREMENT_ID = 'G-W07J2JXYP6';

function getWindowSafely() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window;
}

export function isAnalyticsReady() {
  const win = getWindowSafely();
  return Boolean(win && typeof win.gtag === 'function');
}

export function getAnalyticsContext() {
  const win = getWindowSafely();

  if (!win) {
    return {
      host_name: '',
      page_location: '',
      page_path: '',
      page_title: '',
    };
  }

  return {
    host_name: win.location.hostname,
    page_location: win.location.href,
    page_path: `${win.location.pathname}${win.location.search}`,
    page_title: document.title,
  };
}

export function trackPageView(extraParams = {}) {
  if (!isAnalyticsReady()) {
    return;
  }

  const payload = {
    send_to: GA_MEASUREMENT_ID,
    ...getAnalyticsContext(),
    ...extraParams,
  };

  window.gtag('event', 'page_view', payload);
}

export function trackEvent(eventName, params = {}) {
  if (!isAnalyticsReady()) {
    return;
  }

  const payload = {
    send_to: GA_MEASUREMENT_ID,
    ...getAnalyticsContext(),
    ...params,
  };

  window.gtag('event', eventName, payload);
}

export { GA_MEASUREMENT_ID };